import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useHistory } from "react-router-dom";
//import Global from "../../global";
import "swiper/swiper.min.css";
import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import SwiperCore, {
  Parallax,
  EffectCoverflow,
  Navigation,
  Pagination,
  Autoplay,
} from "swiper/core";
import { getPlaylist, getAWSUrl, getYoutubePlaylist } from "../api/core";
import Anchor from "../Link/anchor";
import LazyImg from "../lazy/lazy";
import Icon from "../icon/icon";
import Global from "../../global";

// install Swiper modules
SwiperCore.use([EffectCoverflow, Navigation, Parallax, Pagination, Autoplay]);

const Threedslider = (props) => {
  const mounted = useRef(false);
  const init = { playlist: [] };
  const y_init = { items: [] };
  const [elem, setElem] = useState([]);
  const [elemItem, setItem] = useState([]);
  const [playlist, setPlaylist] = useState(
    Global.VCMS === "YouTube" ? y_init : init
  );
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [elemdisplay, setElemDisplay] = useState(true);
  const history = useHistory();
  useEffect(() => {
    mounted.current = true;
    const ElemDetail = async () => {
      if (mounted.current) {
        setElem(props.information);

        if (
          props.information.playlistId !== "" &&
          props.information.playlistId !== null &&
          props.information.playlistId !== undefined
        ) {
          playlistDetail(
            props.information.playlistId,
            props.information.devices[0].itemSize
          );
          isLoading(false);
        }
        setElemDisplay(props.information.devices[0].itemVisibility);
        setItem(props.information.items);
      }
    };

    const playlistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */
      if (Global.VCMS === "YouTube") {
        const result = await getYoutubePlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setPlaylist(result.data);
            }
          },
          (error) => {
            if (mounted.current) {
              SetError(false);
              isLoading(false);
            }
          }
        );
      } else {
        const result = await getPlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setPlaylist(result.data);
            }
          },
          (error) => {
            if (mounted.current) {
              SetError(false);
              isLoading(false);
            }
          }
        );
      }

      /* eslint-disable no-unused-vars */
    };

    ElemDetail();

    return () => {
      mounted.current = false;
    };
  }, [props.information]);

  const goTo = (event, loc) => {
    history.push(loc);
  };
  if (
    elemdisplay &&
    !error &&
    !loading &&
    props.information !== null &&
    props.information !== undefined
  ) {
    return (
      <Swiper
        id={props.id}
        slidesPerView={1}
        spaceBetween={0}
        effect={Global.RTL ? "" : "coverflow"}
        autoplay={
          elem.autoPlay
            ? {
                delay: elem.autoPlayTimer,
                disableOnInteraction: !elem.autoPlay,
                pauseOnMouseEnter: elem.autoPlay,
              }
            : ""
        }
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        speed={800}
        breakpoints={{
          800: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          500: {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: false,
          },
          300: {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: false,
          },
        }}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={{
          el: ".swiper-pagination",
          clickable: true,
        }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        parallax={true}
        className="swiper-container threeslider"
        onSwiper={(swiper) => swiper.slideTo(3)}
      >
        <div className="swiper-wrapper">
          {elemItem !== null && elemItem.length > 0
            ? elemItem.map((item, index) => (
                <SwiperSlide
                  key={index}
                  className="swiper-slide swiper-bg"
                  onClick={(event) => {
                    goTo(
                      event,
                      item.itemid.pageType === "externalPage"
                        ? item.itemid.externalPage
                        : item.itemid.pageType === "internalPage"
                        ? item.itemid.internalPage
                        : item.itemid.pageType === "videoPage"
                        ? "/" +
                          props.match.params.AppId +
                          "/" +
                          item.itemid.pageType +
                          "/" +
                          item.itemid.videoId
                        : item.itemid.urlName !== ""
                        ? "/" +
                          props.match.params.AppId +
                          "/" +
                          item.itemid.urlName
                        : item.itemid.pageType + "/" + item.itemid._id
                    );
                  }}
                >
                  <Anchor
                    to={
                      item.itemid.pageType === "externalPage"
                        ? item.itemid.externalPage
                        : item.itemid.pageType === "internalPage"
                        ? item.itemid.internalPage
                        : item.itemid.pageType === "videoPage"
                        ? "/" +
                          props.match.params.AppId +
                          "/" +
                          item.itemid.pageType +
                          "/" +
                          item.itemid.videoId
                        : item.itemid.urlName !== ""
                        ? "/" +
                          props.match.params.AppId +
                          "/" +
                          item.itemid.urlName
                        : item.itemid.pageType + "/" + item.itemid._id
                    }
                    style={{ display: "block" }}
                  >
                    <LazyImg
                      orient="landscape"
                      src={
                        item.itemid.bannerImage
                          ? getAWSUrl() + item.itemid.bannerImage.imagekey
                          : ""
                      }
                      className="entity-img"
                      alt=""
                    />
                    <div className="top-badge">
                      <div className="video-badge">
                        <img
                          className="img-fluid"
                          src="images/top-series.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="content">
                      <p
                        className="title"
                        data-swiper-parallax="-30%"
                        data-swiper-parallax-scale=".7"
                      >
                        {item.itemid.displayName}
                      </p>
                      <span
                        className="caption mb-4"
                        data-swiper-parallax="-20%"
                      >
                        {item.itemid.description}
                      </span>
                      <div
                        className="slider-buttons d-flex align-items-center"
                        data-swiper-parallax="-30%"
                        data-swiper-parallax-scale=".7"
                      ></div>
                    </div>
                  </Anchor>
                </SwiperSlide>
              ))
            : ""}

          {Global.VCMS === "YouTube"
            ? elem.playlistId !== null && elem.playlistId !== undefined
              ? playlist.items.map((item, index) => (
                  <SwiperSlide
                    key={index}
                    className="swiper-slide swiper-bg"
                    onClick={(event) =>
                      goTo(
                        event,
                        "/" +
                          props.match.params.AppId +
                          "/videoPage/" +
                          item.contentDetails.videoId
                      )
                    }
                  >
                    <Anchor
                      to={
                        "/" +
                        props.match.params.AppId +
                        "/videoPage/" +
                        item.contentDetails.videoId
                      }
                      style={{ display: "block" }}
                    >
                      {/* {item.ContentType==="Premium"?<Icon></Icon>:""} */}
                      <LazyImg
                        orient="landscape"
                        src={
                          item.snippet.thumbnails.maxres
                            ? item.snippet.thumbnails.maxres.url
                            : item.snippet.thumbnails.high.url
                        }
                        className="entity-img"
                        alt=""
                      />
                      <div className="top-badge">
                        <div className="video-badge">
                          <img
                            className="img-fluid"
                            src="images/top-series.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="content">
                        <p
                          className="title"
                          data-swiper-parallax="-30%"
                          data-swiper-parallax-scale=".7"
                        >
                          {item.snippet.title}
                        </p>
                        <span
                          className="caption mb-4"
                          data-swiper-parallax="-20%"
                        >
                          {item.snippet.description}
                        </span>
                        <div
                          className="slider-buttons d-flex align-items-center"
                          data-swiper-parallax="-30%"
                          data-swiper-parallax-scale=".7"
                        ></div>
                      </div>
                    </Anchor>
                  </SwiperSlide>
                ))
              : ""
            : elem.playlistId !== null && elem.playlistId !== undefined
            ? playlist.playlist.map((item, index) => (
                <SwiperSlide
                  key={index}
                  className="swiper-slide swiper-bg"
                  onClick={(event) =>
                    goTo(
                      event,
                      "/" +
                        props.match.params.AppId +
                        "/videoPage/" +
                        item.mediaid
                    )
                  }
                >
                  <Anchor
                    to={
                      "/" +
                      props.match.params.AppId +
                      "/videoPage/" +
                      item.mediaid
                    }
                    style={{ display: "block" }}
                  >
                    {item.ContentType === "Premium" ? <Icon></Icon> : ""}
                    <LazyImg
                      orient="landscape"
                      src={item.image}
                      className="entity-img"
                      alt=""
                    />
                    <div className="top-badge">
                      <div className="video-badge">
                        <img
                          className="img-fluid"
                          src="images/top-series.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="content">
                      <p
                        className="title"
                        data-swiper-parallax="-30%"
                        data-swiper-parallax-scale=".7"
                      >
                        {item.title}
                      </p>
                      <span
                        className="caption mb-4"
                        data-swiper-parallax="-20%"
                      >
                        {item.ShortDescription}
                      </span>
                      <div
                        className="slider-buttons d-flex align-items-center"
                        data-swiper-parallax="-30%"
                        data-swiper-parallax-scale=".7"
                      ></div>
                    </div>
                  </Anchor>
                </SwiperSlide>
              ))
            : ""}
        </div>
        {/* Swiper Wrapper End */}
        <div className="swiper-button-prev swiper-button-white" />
        <div className="swiper-button-next swiper-button-white" />
        {/* Navigation Buttons End */}
      </Swiper>
    );
  } else if (elemdisplay && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }
};

export default Threedslider;
